import { SkillTreeBannerProps } from '@components/skillTree/skillTreeBanner/skillTreeBanner';

const convertSkillTreeToBanner = (skillTree: any): SkillTreeBannerProps => {
    return {
        duration: skillTree.duration,
        description: skillTree.description,
        uuid: skillTree.uuid,
        status: skillTree.prgoress?.status || skillTree.status,
        name: skillTree.name
    };
};

export default convertSkillTreeToBanner;
